import { gql, TypedDocumentNode } from "@apollo/client";

import {
  LogScribephoneConsentMutation,
  LogScribephoneConsentMutationVariables,
  ChangeScribephoneConsentModeMutation,
  ChangeScribephoneConsentModeMutationVariables,
} from "./ScribephoneConsent.generated";

export const LOG_SCRIBEPHONE_CONSENT: TypedDocumentNode<
  LogScribephoneConsentMutation,
  LogScribephoneConsentMutationVariables
> = gql`
  mutation LogScribephoneConsent {
    logScribephoneConsent {
      ok
      error
    }
  }
`;

export const CHANGE_SCRIBEPHONE_CONSENT_MODE: TypedDocumentNode<
  ChangeScribephoneConsentModeMutation,
  ChangeScribephoneConsentModeMutationVariables
> = gql`
  mutation ChangeScribephoneConsentMode(
    $consentMode: ScribephoneConsentEnum!
  ) {
    changeScribephoneConsentMode(consentMode: $consentMode) {
      ok
      error
    }
  }
`;
